import React from "react";

import { Outlet } from "react-router-dom";
import LanguageDropdown from "../../LanguageDropdown/LanguageDropdown";

// Concentric rings that ripple out from the centered card, fading with distance.
const RINGS = [
  { r: 31, opacity: 0.8 },
  { r: 39, opacity: 0.5 },
  { r: 47, opacity: 0.25 },
];

export default function PublicLayout() {
  return (
    <div className="relative isolate flex min-h-screen flex-col overflow-hidden bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -left-48 -top-48 h-[40rem] w-[40rem] bg-glow-blue" />
        <div className="absolute -bottom-56 -right-48 h-[44rem] w-[44rem] bg-glow-indigo" />
        <svg
          viewBox="0 0 100 100"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.1"
          className="absolute left-1/2 top-1/2 h-[100rem] w-[100rem] -translate-x-1/2 -translate-y-1/2 text-blue-200"
        >
          {RINGS.map(({ r, opacity }) => (
            <circle key={r} cx="50" cy="50" r={r} strokeOpacity={opacity} />
          ))}
        </svg>
      </div>
      <div className="absolute right-4 top-4 z-10 sm:right-6 sm:top-6">
        <LanguageDropdown className="w-40" />
      </div>
      <main className="flex flex-1 items-center justify-center px-4 pb-10 pt-20 sm:p-12">
        <Outlet />
      </main>
    </div>
  );
}
